import builder from '../builder';
import SingleNeutralActions from '../../streamline-icons/bold/single-neutral-actions.svg';

export default builder('IconSingleNeutralActions', SingleNeutralActions);
